













































































import { Vue, Component, Prop } from "vue-property-decorator";
import CdkFilterPassBadge from "@/components/CdkFilterPassBadge/CdkFilterPassBadge.vue";
import useMatomoEvent from "@/composition/useMatomoEvent";

@Component({
  components: {
    CdkFilterPassBadge
  },
  setup() {
    return {
      useMatomoEvent
    };
  }
})
export default class CdkFilterList extends Vue {
  @Prop() filtersByGroup!: any[];

  @Prop(Boolean) showActions!: boolean;
}
